import { useState } from "react";
import { TextField } from "@material-ui/core";
import UtilService from "../../api/utilService";
import AuthService from "../../api/authService";
import Button from "../../components/Button/button";
import toast from "react-hot-toast";

function Email_User({ setFormStage, setFormData }) {

  const [enteredEmail, setEnteredEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const onSendOtp = () => {

    if (!validateEmail(enteredEmail)) {
      setError("Please enter a valid corporate email address");
      return;
    }
    console.log('got verified locally');
    setIsLoading(true);

    const authService = new AuthService();

    authService
      .getEmailByEmail(enteredEmail)
      .then((userRes) => {
        console.log('userRes : ', userRes);

        // if (userRes.status != 200) {
        //   setError("We could not verify this email address in our system");
        //   setIsLoading(false);
        //   return;
        // }
        
        if (userRes.payload && userRes.payload[0].active !== "0") {
          toast.error("This account has been deactivated. Please contact your system administrator for assistance.");
          setIsLoading(false);
          return;
        }

        const utilService = new UtilService();

        utilService.sendOtp(enteredEmail).then((Otpres) => {
          if (Otpres.status == 200) {
            setIsLoading(false);
            setFormData({
              email: enteredEmail,
              user: userRes?.payload?.[0] || null,
              otpSessionId: Otpres.SessionId,
            });
            setFormStage(1);
          } else {
            toast.error(`Authentication process could not be completed: ${Otpres.statusMsg}`);
            setIsLoading(false);
          }
        });
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        toast.error("We encountered an issue processing your request. Please try again or contact support.");
      });
  };

  const onEnterPassword = () => {
    
    if (!validateEmail(enteredEmail)) {
      setError("Please enter a valid corporate email address");
      return;
    }
  
    setIsLoading(true);
  
    const authService = new AuthService();
  
    authService
      .getEmailByEmail(enteredEmail)
      .then((userRes) => {
        console.log("userRes : ", userRes);
        if (userRes.status != 200) {
          setError("We could not verify this email address in our system");
          setIsLoading(false);
          return;
        }
        if (userRes.payload && userRes.payload[0].active !== "0") {
          toast.error("This account has been deactivated. Please contact your system administrator for assistance.");
          setIsLoading(false);
          return;
        }
  
        setFormData({
          email: enteredEmail,
          user: userRes?.payload?.[0] || null,
        });
        setFormStage(3);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        toast.error("We encountered an issue processing your request. Please try again or contact support.");
      });
  };
  
  const onKeyPressed = (e) => {
    if (e.key === "Enter") {
      console.log("ENTERD KEY DOWN ", enteredEmail);
      e.preventDefault();
      onSendOtp();
    }
  };

  // Enhanced button styles for executive-level appearance
  const buttonStyle = {
    width: "100%",
    padding: "14px 20px",
    fontSize: "15px",
    fontWeight: 500,
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "'Segoe UI', Arial, sans-serif",
  };

  const primaryButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#0055A4", // Deep corporate blue
    color: "#ffffff",
  };

  const secondaryButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#ffffff",
    color: "#0055A4", // Deep corporate blue
    border: "1px solid #0055A4",
  };

  // Refined error style for executive appearance
  const errorMessageStyle = {
    color: "#d32f2f",
    fontSize: "12px",
    marginTop: "4px",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    fontWeight: 400,
  };

  return (
    <div style={{ marginTop: "3em" }}>
      <div style={{ position: "relative" }}>
        <TextField
          style={{
            backgroundColor: "#fff",
            width: "100%",
            borderRadius: "6px",
            minWidth: 80,
            fontSize: "17px",
            height: `${error ? "60px" : "50px"}`,
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
          error={!!error}
          id="standard-basic email"
          InputProps={{
            placeholder: "Enter Corporate Email",
            style: {
              height: `${error ? "65%" : "100%"}`,
              paddingLeft: "12px",
              color: "#333333",
              fontFamily: "'Segoe UI', Arial, sans-serif",
            },
          }}
          type="email"
          variant="standard"
          placeholder="Email"
          name="email"
          onKeyDown={onKeyPressed}
          onChange={(e) => {
            let text = e.currentTarget.value;
            setEnteredEmail(text);
            if (validateEmail(text)) {
              setError("");
            }
          }}
          value={enteredEmail}
          autoComplete="username"
        />
        {error && <div style={errorMessageStyle}>{error}</div>}
      </div>
      <div style={{ 
        paddingTop: "20px",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        marginBottom: "20px"
      }}>
        <div style={{ width: "100%", marginBottom: "16px" }}>
          {isLoading ? (
            <button
              style={{...primaryButtonStyle, marginBottom: 0}}
              disabled
            >
              <span style={{ marginRight: "10px" }}>Processing</span>
              <div className="spinner" style={{ 
                width: "16px", 
                height: "16px", 
                border: "2px solid rgba(255, 255, 255, 0.3)", 
                borderRadius: "50%", 
                borderTopColor: "#ffffff", 
                animation: "spin 1s linear infinite" 
              }}></div>
            </button>
          ) : (
            <button
              style={{...primaryButtonStyle, marginBottom: 0}}
              onClick={onSendOtp}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#004183";
                e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.15)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "#0055A4";
                e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
              }}
            >
              Send OTP
            </button>
          )}
        </div>
        <div style={{ width: "100%" }}>
          <button
            style={{...secondaryButtonStyle, marginBottom: 0}}
            onClick={onEnterPassword}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#f5f8fe";
              e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.15)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "#ffffff";
              e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
            }}
          >
            Sign in with Password
          </button>
        </div>
      </div>
      <style jsx>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default Email_User;